module.exports = __webpack_public_path__ + "img/college_mid_bg.93470acd.jpg";